/* eslint-disable no-nested-ternary */
import { useUser } from '@folklore/auth';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useTheme, useThemeClassName } from '../../contexts/ThemeContext';
import EnterPinCodeForm from '../forms/EnterPincodeForm';
import HourGlass from '../icons/Hourglass';
import Logo from '../icons/Logo';
import QRCode from '../icons/QRCode';
import LiveGameCard from '../partials/LiveGameCard';

import styles from '../../../styles/steps/pincode.module.scss';

const propTypes = {
    game: PropTypes.shape({}),
    participation: PropTypes.shape({}),
    isUser: PropTypes.bool,
    isDisplay: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    game: null,
    participation: null,
    isUser: false,
    isDisplay: false,
    className: null,
};

function Pincode({ game, participation, isUser, isDisplay, className }) {
    const { name: theme = null } = useTheme();
    const themeClassName = useThemeClassName(styles);
    const { pincodes = null, title = null, subtitle = null } = game || {};
    const [{ code: pincode = null } = {}] = pincodes || [];

    // TODO: important - this pincode check has to be re-enabled
    // for the next live quiz concours

    // console.log('user', user, 'gamePincode', pincode);

    const { id: participationId = null, pincode: participationPincode = null } =
        participation || {};
    const hasPincode = participationPincode !== null;
    const showWaiting = isUser && hasPincode;

    return (
        <div
            className={classNames([
                styles.container,
                themeClassName,
                { [styles.isDisplay]: isDisplay, [className]: className !== null },
            ])}
        >
            <div className={styles.inner}>
                {isUser ? (
                    showWaiting ? (
                        <div className={styles.waiting}>
                            <HourGlass className={styles.icon} />
                            <h4 className={styles.title}>
                                <FormattedMessage
                                    defaultMessage="The challenge will begin when all participants are ready."
                                    description="Step title"
                                />
                            </h4>
                            <LiveGameCard game={game} />
                            <p className={styles.description}>
                                <FormattedMessage
                                    defaultMessage="Please don't shout the answers!"
                                    description="Step title"
                                />
                            </p>
                        </div>
                    ) : (
                        <EnterPinCodeForm
                            title={
                                hasPincode ? (
                                    <FormattedMessage
                                        defaultMessage="Waiting for the other participants..."
                                        description="Form title"
                                    />
                                ) : (
                                    <FormattedMessage
                                        defaultMessage="Enter the PIN shown on the screens to start playing."
                                        description="Form title"
                                    />
                                )
                            }
                            className={styles.form}
                            value={hasPincode ? participationPincode : null}
                            participation={participation}
                            disabled={hasPincode}
                        />
                    )
                ) : (
                    <div className={styles.inner}>
                        {isDisplay ? (
                            <>
                                <Logo className={styles.logo} component={`${theme}-vertical`} />
                                <h3 className={styles.title}>
                                    <FormattedMessage
                                        defaultMessage="The challenge starts soon:"
                                        description="Step label"
                                    />
                                    <br /> {title} {subtitle !== null ? ` - ${subtitle}` : null}
                                </h3>
                            </>
                        ) : null}
                        <div className={styles.pincode}>
                            <h3 className={styles.pinTitle}>
                                <FormattedMessage
                                    defaultMessage="Enter this PIN in to start playing."
                                    description="Step label"
                                />
                            </h3>
                            <div className={styles.pinContainer}>
                                <div className={styles.pin}>{pincode}</div>
                            </div>
                        </div>
                        {isDisplay ? (
                            <div className={styles.qrcodeContainer}>
                                <p className={styles.description}>
                                    <FormattedMessage
                                        defaultMessage="Scan the QR code to enter."
                                        description="Display message"
                                    />
                                </p>
                                <QRCode className={styles.qrcode} component={theme} />
                            </div>
                        ) : null}
                    </div>
                )}
            </div>
        </div>
    );
}

Pincode.propTypes = propTypes;
Pincode.defaultProps = defaultProps;

export default Pincode;
